export const ErrorCodes = {
    // Organization-related errors
    EOrganizationMissing: 'EOrganizationMissing',
    EOrganizationLimit: 'EOrganizationLimit',
    EInvalidOrganization: 'EInvalidOrganization',
    /** We could not validate the Tax ID provided */
    ETaxIdInvalid: 'ETaxIdInvalid',
    /** Tax ID was rejected (by stripe) */
    ETaxIdRejected: 'ETaxIdRejected',
    // Payment-related errors
    EPaymentMethodNotFound: 'EPaymentMethodNotFound',
    EPaymentMethodInvalid: 'EPaymentMethodInvalid',
    EPaymentFailed: 'EPaymentFailed',
    EBillingAddressRequired: 'EBillingAddressRequired',
    // Signing-related errors
    ESigningNotFound: 'ESigningNotFound',
    ESigningCannotBeDeleted: 'ESigningCannotBeDeleted',
    ESigningCannotBeStarted: 'ESigningCannotBeStarted',
    ESigningCannotBeUpdated: 'ESigningCannotBeUpdated',
    EUnauthorizedSigningCreation: 'EUnauthorizedSigningCreation',
    EUnverifiedUserSigningLimitReached: 'EUnverifiedUserSigningLimitReached',
    ESigningsPerDayLimitReached: 'ESigningsPerDayLimitReached',
    ESignersLimitReached: 'ESignersLimitReached',
    ESignersNotFound: 'ESignersNotFound',
    EComponentsPerSignerLimitReached: 'EComponentsPerSignerLimitReached',
    ESigningKycDataMissing: 'ESigningKycUserDataMissing',
    EInvalidSignatureType: 'EInvalidSignatureType',
    EVerificationSecuritySigningFailed: 'EVerificationSecuritySigningFailed',
    // Singing - signing action related errors
    ESignerNotFound: 'ESignerNotFound',
    ESignerCantSign: 'ESignerCantSign',
    ESigningNotInSigningState: 'ESigningNotInSigningState', // Invalid signing state
    ESignerAlreadySigned: 'ESignerAlreadySigned',
    ESignerIsAlreadySigning: 'ESignerIsAlreadySigning',
    ESignIsLocked: 'ESignIsLocked',
    ESignerNotInSigningState: 'ESignerNotInSigningState',
    EUserAlreadyOnSigning: 'EUserAlreadyOnSigning',
    ESignMissingComponent: 'ESignMissingComponent',
    ESignInvalidComponent: 'ESignInvalidComponent',
    ESignAlreadyAssociated: 'ESignAlreadyAssociated',
    ESigningArchived: 'ESigningArchived',
    ETrustedSignerMustLogin: 'ETrustedSignerMustLogin',
    ESigningCannotBeCancelled: 'ESigningCannotBeCancelled',
    EEnhancedSecurityPinRequired: 'EEnhancedSecurityPinRequired',
    EEnhancedSecurityPasswordRequired: 'EEnhancedSecurityPasswordRequired',
    EEnhancedSecuritySMSPinRequired: 'EEnhancedSecuritySMSPinRequired',
    ESignerCannotReceiveReminder: 'ESignerCannotReceiveReminder',
    ESignerReminderRateLimited: 'ESignerReminderRateLimited',
    ESignerCannotBeReassigned: 'ESignerCannotBeReassigned',
    ERepresentativesAlreadyNamed: 'ERepresentativesAlreadyNamed',
    ERepresentativesCapExceeded: 'ERepresentativesCapExceeded',
    ERepresentativeDuplicateEmail: 'ERepresentativeDuplicateEmail',
    ERepresentativePhoneRequired: 'ERepresentativePhoneRequired',
    ECompanyContactCannotSign: 'ECompanyContactCannotSign',
    // Document-related errors
    EDocumentNotFound: 'EDocumentNotFound',
    EDocumentNotEditable: 'EDocumentNotEditable',
    EDocumentDeletionRestricted: 'EDocumentDeletionRestricted',
    EDocumentComponentNotFound: 'EDocumentComponentNotFound',
    EPageNumberMissing: 'EPageNumberMissing',
    EInvalidPageNumber: 'EInvalidPageNumber',
    EDocumentsSizeLimitReached: 'EDocumentsSizeLimitReached',
    EDocumentsPerSigningLimitReached: 'EDocumentsPerSigningLimitReached',
    EDocumentInvalidPageCount: 'EDocumentInvalidPageCount',
    // Invitation-related errors
    EInvitationViewersNotFound: 'EInvitationViewersNotFound',
    EInvitationSignersNotFound: 'EInvitationSignersNotFound',
    EInvitationNotFound: 'EInvitationNotFound',
    EInvitationExpired: 'EInvitationExpired',
    EInvitationResendThrottleReached: 'EInvitationResendThrottleReached',
    EInvalidCode: 'EInvalidCode',
    // File-related errors
    EInvalidFileType: 'EInvalidFileType',
    EErrorProcessingPdf: 'EErrorProcessingPdf',
    EEncryptedPdf: 'EEncryptedPdf',
    EConversionFailed: 'EConversionFailed',
    EDocumentNotReady: 'EDocumentNotReady',
    // Contact-related errors
    EContactNotFound: 'EContactNotFound',
    // Permission-related errors
    EAccessDenied: 'EAccessDenied',
    // Subscription-related errors
    ESubscriptionNotActive: 'ESubscriptionNotActive',
    ESubscriptionNotChanged: 'ESubscriptionNotChanged',
    ESubscriptionAlreadyActive: 'ESubscriptionAlreadyActive',
    ENoSubscription: 'ENoSubscription',
    ESubscriptionPaymentRequiresAction: 'ESubscriptionPaymentRequiresAction',
    ESubscriptionPendingChange: 'ESubscriptionPendingChange',
    ESubscriptionPlanNotEligible: 'ESubscriptionPlanNotEligible',
    EWithdrawalConsentRequired: 'EWithdrawalConsentRequired',
    EUsageAllowanceExhausted: 'EUsageAllowanceExhausted',
    ECompanySignerRequiresPaymentDetails: 'ECompanySignerRequiresPaymentDetails',
    //User-related errors
    EUserNotFound: 'EUserNotFound',
    EUserOnboardingIncomplete: 'EUserOnboardingIncomplete',
    EInvalidCredentials: 'EInvalidCredentials',
    EUserSuspended: 'EUserSuspended',
    EVerificationLimitReached: 'EVerificationLimitReached',
    EVerificationThrottleReached: 'EVerificationThrottleReached',
    EPhoneVerificationNotNeeded: 'EPhoneVerificationNotNeeded',
    EPhoneVerificationNeeded: 'EPhoneVerificationNeeded',
    EPhoneVerificationExpired: 'EPhoneVerificationExpired',
    EPhoneNumberNotSet: 'EPhoneNumberNotSet',
    EUserAlreadyExists: 'EUserAlreadyExists',
    EEmailVerificationNeeded: 'EEmailVerificationNeeded',
    EEmailAlreadyVerified: 'EEmailAlreadyVerified',
    EInvalidOldPassword: 'EInvalidOldPassword',
    EUserAlreadyInOrganization: 'EUserAlreadyInOrganization',
    EKycMissing: 'EKycMissing',
    EUnsupportedLanguage: 'EUnsupportedLanguage',
    EUserCannotSuspendSelf: 'EUserCannotSuspendSelf',
    EUserInvalidStateForSuspension: 'EUserInvalidStateForSuspension',
    EEmailNotificationsNotFound: 'EEmailNotificationsNotFound',
    EInvalidToken: 'EInvalidToken',
    ENoPendingUpdate: 'ENoPendingUpdate',
    EUserDataChangeLimitReached: 'EUserDataChangeLimitReached',
    ECustomerDeleted: 'ECustomerDeleted',
    EOnboardingAlreadyCompleted: 'EOnboardingAlreadyCompleted',
    EInvalidRefreshToken: 'EInvalidRefreshToken',
    EIdentityNotFound: 'EIdentityNotFound',
    EPinAlreadySet: 'EPinAlreadySet',
    EUserNotExternal: 'EUserNotExternal',
    EInvalidPinLength: 'EInvalidPinLength',
    // Signup-abuse protection
    /** Signup refused: email failed the anti-bot heuristic. */
    ESignupRejected: 'ESignupRejected',
    /** Account-creation blocked: source IP tripped the signup abuse threshold. */
    EIpBanned: 'EIpBanned',
    //Template-related errors
    ETemplateInvalid: 'ETemplateInvalid',
    ETemplatesPerDayLimitReached: 'ETemplatesPerDayLimitReached',
    ETemplateNotFound: 'ETemplateNotFound',
    ETemplateInvalidSigner: 'ETemplateInvalidSigner',
    // PDF/A conversion errors
    EPdfaConversionRateLimitReached: 'EPdfaConversionRateLimitReached',
    // DOCX to PDF conversion errors
    EDocxConversionRateLimitReached: 'EDocxConversionRateLimitReached',
    // C2PA Content Credentials errors
    EC2paDisabled: 'EC2paDisabled',
    EC2paRateLimitReached: 'EC2paRateLimitReached',
    // Review-related errors
    EReviewerDuplicated: 'EReviewerDuplicated',
    EReviewAlreadyApproved: 'EReviewAlreadyApproved',
    EReviewAlreadyReviewed: 'EReviewAlreadyReviewed',
    ESigningCannotBeReviewed: 'ESigningCannotBeReviewed',
    // Safe-transfer-related errors
    ESafeTransferNotFound: 'ESafeTransferNotFound',
    ESafeTransferNotEditable: 'ESafeTransferNotEditable',
    ESafeTransferCannotBeSent: 'ESafeTransferCannotBeSent',
    ESafeTransferCannotBeRevoked: 'ESafeTransferCannotBeRevoked',
    ESafeTransferRecipientNotFound: 'ESafeTransferRecipientNotFound',
    ESafeTransferRecipientDuplicated: 'ESafeTransferRecipientDuplicated',
    ESafeTransferNoRecipients: 'ESafeTransferNoRecipients',
    ESafeTransferNoFiles: 'ESafeTransferNoFiles',
    ESafeTransferNoPaymentMethod: 'ESafeTransferNoPaymentMethod',
    ESafeTransferCodeNotAvailable: 'ESafeTransferCodeNotAvailable',
    ESafeTransferCodeAlreadyClaimed: 'ESafeTransferCodeAlreadyClaimed',
    ESafeTransferCodeInvalid: 'ESafeTransferCodeInvalid',
    ESafeTransferCodeLocked: 'ESafeTransferCodeLocked',
    ESafeTransferFileNotFound: 'ESafeTransferFileNotFound',
    ESafeTransferInvalidFileType: 'ESafeTransferInvalidFileType',
    ESafeTransferFileSizeLimitReached: 'ESafeTransferFileSizeLimitReached',
    ESafeTransferTotalSizeLimitReached: 'ESafeTransferTotalSizeLimitReached',
    ESafeTransferExpired: 'ESafeTransferExpired',
    ESafeTransferRevoked: 'ESafeTransferRevoked',
    ESafeTransferRecipientRevoked: 'ESafeTransferRecipientRevoked',
    ESafeTransferNotUnlocked: 'ESafeTransferNotUnlocked',
    ESafeTransferConsumed: 'ESafeTransferConsumed',
    ESafeTransferVerificationFailed: 'ESafeTransferVerificationFailed',
    // MCP server and OAuth authorization server errors
    EMcpAccessExpired: 'EMcpAccessExpired',
    EMcpAccessBlocked: 'EMcpAccessBlocked',
    EMcpDisabled: 'EMcpDisabled',
    EMcpUploadNotFound: 'EMcpUploadNotFound',
    EMcpUploadAlreadyUsed: 'EMcpUploadAlreadyUsed',
    EOAuthInvalidClient: 'EOAuthInvalidClient',
    EOAuthInvalidRequest: 'EOAuthInvalidRequest',
    EOAuthAuthorizationNotFound: 'EOAuthAuthorizationNotFound',
    EInsufficientScope: 'EInsufficientScope',
    ERateLimited: 'ERateLimited',
    ENotFound: 'ENotFound',
    EInvalidInput: 'EInvalidInput',
    EInternal: 'EInternal',
    // Staff admin panel
    EForbidden: 'EForbidden',
    EStaffUnauthenticated: 'EStaffUnauthenticated',
    EStaffAlreadyExists: 'EStaffAlreadyExists',
    EStaffSelfChange: 'EStaffSelfChange',
    EAdminUserAlreadySuspended: 'EAdminUserAlreadySuspended',
    EAdminUserNotSuspended: 'EAdminUserNotSuspended',
    EAdminUserInvalidState: 'EAdminUserInvalidState',
    EAdminNotShadowBanned: 'EAdminNotShadowBanned',
    EAdminPhoneNotVerified: 'EAdminPhoneNotVerified',
    EAdminInvalidLanguage: 'EAdminInvalidLanguage',
    EAdminBillingExemptUnchanged: 'EAdminBillingExemptUnchanged',
    EAdminMcpAlreadyBlocked: 'EAdminMcpAlreadyBlocked',
    EAdminMcpNotBlocked: 'EAdminMcpNotBlocked',
    EAdminSigningNotActive: 'EAdminSigningNotActive',
    EAdminSignerAlreadySigned: 'EAdminSignerAlreadySigned',
    EAdminInvitationNotPending: 'EAdminInvitationNotPending',
    EAdminSubscriptionNotActive: 'EAdminSubscriptionNotActive',
    EAdminSubscriptionAlreadyActive: 'EAdminSubscriptionAlreadyActive',
    EAdminSubscriptionUnchanged: 'EAdminSubscriptionUnchanged',
    EAdminSubscriptionNotEligible: 'EAdminSubscriptionNotEligible',
    EAdminIntervalChangePending: 'EAdminIntervalChangePending',
    EAdminNoIntervalChange: 'EAdminNoIntervalChange',
    EAdminNoBillingCustomer: 'EAdminNoBillingCustomer',
    EAdminNoPaymentMethod: 'EAdminNoPaymentMethod',
    EAdminBillingAddressRequired: 'EAdminBillingAddressRequired',
    EAdminWithdrawalConsentRequired: 'EAdminWithdrawalConsentRequired',
    EAdminPaymentFailed: 'EAdminPaymentFailed',
    EAdminNotEnterprise: 'EAdminNotEnterprise',
};
